module.exports = __webpack_public_path__ + "static/mr-online-program-music-world-wide-4-b7d57a593be072f32c447996a55dad99.jpg";